/**
 * Builds a unique namespaced question id for the element.
 * @param questionId id of the question in the application
 */
export const buildQuestionElementId = (questionId: string) =>
  `application-question-${questionId}`;
